<template>
  <transition name="fade">
    <div v-if="show" class="video-popup">
      <CloseIcon class="close" @click.native="$emit('close')" />
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppVideoPopup',
  components: {
    CloseIcon: () => import('@/components/icons/CloseIcon'),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/common/AppVideoPopup';
</style>
